<template>
<div>
  <el-steps :space="200" :active="step" finish-status="success" align-center class="is-underline">
    <el-step>
      <template v-slot:title="scope">
        <span :class="canGoToStep(0) ? 'cursor-pointer' : ''" @click="goToStep(0)">
          <i class="el-icon-arrow-right" v-if="canGoToStep(0)"></i>
          Company Detail
        </span>
      </template>
    </el-step>
    <el-step>
      <template v-slot:title="scope">
        <span :class="canGoToStep(1) ? 'cursor-pointer' : ''" @click="goToStep(1)">
          <i class="el-icon-arrow-right" v-if="canGoToStep(1)"></i>
          Contacts
        </span>
      </template>
    </el-step>
    <el-step>
      <template v-slot:title="scope">
        <span :class="canGoToStep(2) ? 'cursor-pointer' : ''" @click="goToStep(2)">
          <i class="el-icon-arrow-right" v-if="canGoToStep(2)"></i>
          Upload Document
        </span>
      </template>
    </el-step>
    <el-step>
      <template v-slot:title="scope">
        <span :class="canGoToStep(4) ? 'cursor-pointer' : ''" @click="goToStep(4)" @dblclick="debugMode()">
          <i class="el-icon-arrow-right" v-if="canGoToStep(4)"></i>
          Preview
        </span>
      </template>
    </el-step>
  </el-steps>

  <div v-loading="isLoading">
    <div class="my-2" v-if="step === 0">
      <el-form :model="row" :rules="rules" ref="mainForm" class="compact">
      <b-row>
        <b-col lg="6">
          <el-form-item :label="$t('Company Name (Invoice)')" prop="companyName">
            <el-input size="small" v-model="row.companyName" maxlength="255"/>
          </el-form-item>

          <el-form-item :label="$t('Company Name (System)')" prop="companyNameInternal">
            <el-input size="small" v-model="row.companyNameInternal" maxlength="255"/>
          </el-form-item>

          <el-form-item :label="$t('Company Address')" prop="companyAddress">
            <el-input size="small" v-model="row.companyAddress" maxlength="255"/>
          </el-form-item>

          <el-form-item :label="$t('BR Number (For HK Company)')" prop="brNumber">
            <el-input size="small" v-model="row.brNumber" maxlength="32"/>
          </el-form-item>

          <el-form-item :label="$t('Company Type')" prop="companyType">
            <div class="mt-2">
              <el-radio v-model="row.companyType" label="External">External</el-radio>
              <el-radio v-model="row.companyType" label="InterCom">InterCom</el-radio>
            </div>
          </el-form-item>

          <el-form-item :label="$t('Payment Terms (Days)')" prop="paymentTermDays">
            <el-input size="small" v-model="row.paymentTermDays" type="number" min="0" max="3650"/>
          </el-form-item>

          <el-form-item :label="$t('Key Account')" prop="keyAccount">
            <el-input size="small" v-model="row.keyAccount" maxlength="255"/>
          </el-form-item>

          <el-form-item :label="$t('Contract End Date')">
            <el-input size="small" v-model="row.contractEndDate" placeholder="YYYY-MM-DD"/>
          </el-form-item>

          <el-form-item :label="$t('Contract Inactive')">
            <div style="clear: both">
              <el-checkbox size="small" v-model="row.contractEndInactive"/>
            </div>
          </el-form-item>
        </b-col>
        <b-col lg="6">
          <el-form-item :label="$t('ERP Account Code')" prop="accountCode">
            <el-input size="small" v-model="row.accountCode" maxlength="32" @input="validateAccountCode"/>
          </el-form-item>

          <el-form-item :label="$t('Country Code')" prop="country">
            <el-input size="small" v-model="row.country" maxlength="4"/>
          </el-form-item>

          <el-form-item :label="$t('Corporate Registration Number')" prop="corporateRegistrationNumber">
            <el-input size="small" v-model="row.corporateRegistrationNumber" maxlength="64"/>
          </el-form-item>

          <el-form-item :label="$t('Contract Type')" prop="contractType">
            <el-input size="small" v-model="row.contractType" maxlength="32"/>
          </el-form-item>

          <el-form-item :label="$t('Default Currency Code')" prop="paymentCurrency">
            <el-input size="small" v-model="row.paymentCurrency" maxlength="3"/>
          </el-form-item>

          <el-form-item :label="$t('Tags')" prop="tags">
            <el-input size="small" v-model="row.tags"/>
          </el-form-item>

          <el-form-item :label="$t('ICP Number')" prop="keyAccount">
            <el-input size="small" v-model="row.icpNumber" maxlength="32"/>
          </el-form-item>

          <el-form-item :label="$t('Contract End Alert Emails')">
            <el-input size="small" v-model="row.contractEndAlertEmails" placeholder="Email addresses separated by ,"/>
          </el-form-item>

          <el-form-item :label="$t('Credit Limit')">
            <el-input size="small" v-model="row.creditAmount" type="number" min="0"/>
          </el-form-item>

          <el-form-item :label="$t('Deposit')">
            <el-input size="small" v-model="row.deposit" type="number" min="0"/>
          </el-form-item>
        </b-col>
      </b-row>
      </el-form>
    </div>

    <div class="my-2" v-if="step === 1">
      <h3>
        Company Contacts
        <el-button size="mini" type="success" class="float-right" @click="addCompanyContact()"><i class="el-icon-plus"></i>  Add Company Contact</el-button>
      </h3>

      <el-card class="box-card mb-2" v-for="(companyContact, k) in row.companyContacts" :key="'cc' + k">
        <b-row>
          <b-col lg="3">
            <b-form-group :label="$t('Name')">
              <template v-slot:label="scope">
                <span class="required" v-if="companyContact.isRequired">*</span>
                {{ $t('Name') }}
              </template>
              <el-input size="small" v-model="companyContact.name" maxlength="255"/>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group :label="$t('Phone')">
              <template v-slot:label="scope">
                <span class="required" v-if="companyContact.isRequired">*</span>
                {{ $t('Phone') }}
              </template>
              <el-input size="small" v-model="companyContact.phone" maxlength="32"/>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group :label="$t('Email')">
              <template v-slot:label="scope">
                <span class="required" v-if="companyContact.isRequired">*</span>
                {{ $t('Email') }}
              </template>
              <el-input type="email" size="small" v-model="companyContact.email" maxlength="255"/>
            </b-form-group>
          </b-col>

          <b-col lg="1">
            <el-button type="danger" class="mt-1" v-if="!companyContact.isRequired && !companyContact.id" @click="removeCompanyContact(k)"><i class="el-icon-delete"></i> Remove</el-button>
            <el-button type="danger" class="mt-1" v-if="!companyContact.isRequired && companyContact.id" @click="removeCompanyContactRemote(k, companyContact)"><i class="el-icon-delete"></i> Remove</el-button>
          </b-col>
        </b-row>
      </el-card>

      <hr/>

      <h3>
        F&amp;A Contacts
        <el-button size="mini" type="success" class="float-right" @click="addFaContact()"><i class="el-icon-plus"></i>  Add F&amp;A Contact</el-button>
      </h3>
      <el-card class="" v-for="(faContact, k) in row.faContacts" :key="'fc-' + k">
        <b-row>
          <b-col lg="3">
            <b-form-group :label="$t('Name')">
              <template v-slot:label="scope">
                <span class="required" v-if="faContact.isRequired">*</span>
                {{ $t('Name') }}
              </template>
              <el-input size="small" v-model="faContact.name" maxlength="255"/>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group :label="$t('Phone')">
              <template v-slot:label="scope">
                <span class="required" v-if="faContact.isRequired">*</span>
                {{ $t('Phone') }}
              </template>
              <el-input size="small" v-model="faContact.phone" maxlength="32"/>
            </b-form-group>
          </b-col>

          <b-col lg="3">
            <b-form-group :label="$t('Email')">
              <template v-slot:label="scope">
                <span class="required" v-if="faContact.isRequired">*</span>
                {{ $t('Email') }}
              </template>
              <el-input type="email" size="small" v-model="faContact.email" maxlength="255"/>
            </b-form-group>
          </b-col>

          <b-col lg="1">
            <el-button type="danger" class="mt-1" v-if="!faContact.isRequired && !faContact.id" @click="removeFaContact(k)"><i class="el-icon-delete"></i> Remove</el-button>
            <el-button type="danger" class="mt-1" v-if="!faContact.isRequired && faContact.id" @click="removeFaContactRemote(k, faContact)"><i class="el-icon-delete"></i> Remove</el-button>
          </b-col>
        </b-row>
      </el-card>
    </div>

    <div class="my-2" v-if="step === 2">
      <el-card class="mb-2" v-for="(document, k) in row.documents" :key="k">
        <!-- Row 1: Primary Info -->
        <b-row>
          <b-col lg="2">
            <b-form-group :label="$t('Document Type')">
              <template v-slot:label="scope">
                <span class="required" v-if="document.isRequired">*</span>
                {{ $t('Document Type') }}
              </template>
              <el-select size="small" v-model="document.type" placeholder="Select" style="width: 100%">
                <el-option v-for="item in documentTypeOptions" :key="item.code" :label="item.label" :value="item.label"/>
              </el-select>
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('Description')">
              <el-input size="small" v-model="document.description" maxlength="500" placeholder="Document description"/>
            </b-form-group>
          </b-col>
          <b-col lg="1">
            <b-form-group label=" ">
              <el-checkbox v-model="document.isSubsequentDocument">Subsequent</el-checkbox>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group :label="$t('File')">
              <el-button v-if="document.clientFilename !== null" class="text-ellipsis-button" size="small" @click="openDocument(document)">{{ document.clientFilename }}</el-button>
              <el-button v-if="document.clientFilename === null" size="small" @click="uploadDocument(k)"><i class="el-icon-upload2"></i> Upload</el-button>
              <el-button type="info" size="small" v-if="document.clientFilename !== null" @click="uploadDocument(k)"><i class="el-icon-refresh"></i></el-button>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group label=" ">
              <el-badge :value="getTotalActionAttachments(document)" :hidden="getTotalActionAttachments(document) === 0" class="action-badge">
                <el-button type="primary" size="small" @click="openActionsModal(k)"><i class="el-icon-s-operation"></i> Actions</el-button>
              </el-badge>
              <el-button type="info" size="small" v-if="document.id" @click="openShareModal(k, document)"><i class="el-icon-share"></i> Share</el-button>
              <el-button type="danger" size="small" v-if="!document.id" @click="removeDocument(k)"><i class="el-icon-delete"></i></el-button>
              <el-button type="danger" size="small" v-if="document.id" @click="removeDocumentRemote(k, document)"><i class="el-icon-delete"></i></el-button>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Row 2: Document Details -->
        <b-row>
          <b-col lg="2">
            <b-form-group :label="$t('Document Number')">
              <el-input size="small" v-model="document.documentNumber" maxlength="255" placeholder="Auto-generated if empty"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Box File No')">
              <el-input size="small" v-model="document.boxFileNo" maxlength="255"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Client Code(DOC)')">
              <el-input size="small" v-model="document.clientCodeDoc" maxlength="255" placeholder="Client Code for Document"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Date of Issue')">
              <el-date-picker size="small" v-model="document.dateOfIssue" type="date" value-format="yyyy-MM-dd" placeholder="YYYY-MM-DD" style="width: 100%"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Date of Expiry')">
              <el-date-picker size="small" v-model="document.dateOfExpiry" type="date" value-format="yyyy-MM-dd" placeholder="YYYY-MM-DD" style="width: 100%"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('PIC')">
              <el-select size="small" v-model="document.handleByUser" placeholder="Select" style="width: 100%" filterable clearable>
                <el-option v-for="user in usersList" :key="user.id" :label="user.name" :value="String(user.id)"/>
              </el-select>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('PIC (for notification)')">
              <el-select size="small" v-model="document.picForNotification" placeholder="Select users" style="width: 100%" filterable clearable multiple>
                <el-option v-for="user in usersList" :key="user.id" :label="user.name" :value="String(user.id)"/>
              </el-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Row 3: Options -->
        <b-row>
          <b-col lg="2">
            <b-form-group :label="$t('Contract Template')">
              <el-select size="small" v-model="document.contractTemplate" placeholder="Select" style="width: 100%">
                <el-option v-for="item in contractTemplateOptions" :key="item" :label="item" :value="item"/>
              </el-select>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Status')">
              <el-select size="small" v-model="document.status" placeholder="Select" style="width: 100%">
                <el-option v-for="item in documentStatusOptions" :key="item" :label="item" :value="item"/>
              </el-select>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Payment Term')">
              <el-input size="small" type="number" min="0" v-model="document.paymentTerm"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Deposit')">
              <el-input size="small" type="number" min="0" v-model="document.deposit"/>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Currency')">
              <el-select size="small" v-model="document.depositCurrency" placeholder="Select" style="width: 100%" clearable>
                <el-option label="HKD" value="HKD"/>
                <el-option label="USD" value="USD"/>
                <el-option label="CNY" value="CNY"/>
                <el-option label="EUR" value="EUR"/>
              </el-select>
            </b-form-group>
          </b-col>
          <b-col lg="2">
            <b-form-group :label="$t('Remarks')">
              <el-input size="small" v-model="document.remarks" maxlength="1000" placeholder="Remarks"/>
            </b-form-group>
          </b-col>
        </b-row>
      </el-card>
    </div>

    <div class="mt-2" v-if="step === 3">
      <el-form :model="row" ref="previewForm" class="compact-no-validation">
      <b-card>
        <b-row>
          <b-col lg="6">
            <h3>
              Company Detail
            </h3>
            <b-row>
              <b-col lg="6">
                <el-form-item :label="$t('Company Name (Invoice)')">
                  <el-input size="mini" v-model="row.companyName" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Company Name (System)')">
                  <el-input size="mini" v-model="row.companyNameInternal" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Company Address')">
                  <el-input size="mini" v-model="row.companyAddress" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('BR Number (For HK Company)')">
                  <el-input size="mini" v-model="row.brNumber" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Company Type')">
                  <el-input size="mini" v-model="row.companyType" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Payment Terms (Days)')">
                  <el-input size="mini" v-model="row.paymentTermDays" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Key Account')">
                  <el-input size="mini" v-model="row.keyAccount" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Contract End Date')">
                  <el-input size="small" v-model="row.contractEndDate" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Contract Inactive')">
                  <div style="clear: both">
                    <el-checkbox size="small" v-model="row.contractEndInactive" disabled/>
                  </div>
                </el-form-item>
              </b-col>

              <b-col lg="6">
                <el-form-item :label="$t('ERP Account Code')">
                  <el-input size="mini" v-model="row.accountCode" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Country')">
                  <el-input size="mini" v-model="row.country" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Corporate Registration Number')">
                  <el-input size="mini" v-model="row.corporateRegistrationNumber" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Contract Type')">
                  <el-input size="mini" v-model="row.contractType" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Payment Currency')">
                  <el-input size="mini" v-model="row.paymentCurrency" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Tags')">
                  <el-input size="mini" v-model="row.tags" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('ICP Number')">
                  <el-input size="mini" v-model="row.icpNumber" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Contract End Alert Emails')">
                  <el-input size="mini" v-model="row.contractEndAlertEmails" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Credit Limit')">
                  <el-input size="mini" v-model="row.creditAmount" readonly="readonly"/>
                </el-form-item>

                <el-form-item :label="$t('Deposit')">
                  <el-input size="mini" v-model="row.deposit" readonly="readonly"/>
                </el-form-item>
              </b-col>
            </b-row>

            <hr/>

            <h3>
              Company Contacts
            </h3>

            <div class="box-card mb-2" v-for="(companyContact, k) in row.companyContacts" :key="'cc' + k">
              <b-row>
                <b-col lg="4">
                  <b-form-group :label="$t('Name')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="companyContact.isRequired">*</span>
                      {{ $t('Name') }}
                    </template>
                    <el-input size="mini" v-model="companyContact.name" readonly="readonly"/>
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group :label="$t('Phone')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="companyContact.isRequired">*</span>
                      {{ $t('Phone') }}
                    </template>
                    <el-input size="mini" v-model="companyContact.phone" readonly="readonly"/>
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group :label="$t('Email')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="companyContact.isRequired">*</span>
                      {{ $t('Email') }}
                    </template>
                    <el-input size="mini" v-model="companyContact.email" readonly="readonly"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <hr/>

            <h3>
              F&amp;A Contacts
            </h3>
            <div class="box-card mb-2" v-for="(faContact, k) in row.faContacts" :key="'fc' + k">
              <b-row>
                <b-col lg="4">
                  <b-form-group :label="$t('Name')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="faContact.isRequired">*</span>
                      {{ $t('Name') }}
                    </template>
                    <el-input size="mini" v-model="faContact.name" readonly="readonly"/>
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group :label="$t('Phone')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="faContact.isRequired">*</span>
                      {{ $t('Phone') }}
                    </template>
                    <el-input size="mini" v-model="faContact.phone" readonly="readonly"/>
                  </b-form-group>
                </b-col>

                <b-col lg="4">
                  <b-form-group :label="$t('Email')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="faContact.isRequired">*</span>
                      {{ $t('Email') }}
                    </template>
                    <el-input size="mini" v-model="faContact.email" readonly="readonly"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>


          <b-col lg="6">
            <h3>
              Documents
            </h3>

            <div v-for="(document, k) in row.documents" :key="k">
              <b-row>
                <b-col lg="3">
                  <b-form-group :label="$t('Document Type')">
                    <template v-slot:label="scope">
                      <span class="required" v-if="document.isRequired">*</span>
                      {{ $t('Document Type') }}
                    </template>
                    <el-input size="mini" v-model="document.type" :readonly="document.isRequired" readonly="readonly"/>
                  </b-form-group>
                </b-col>
                <b-col lg="2">
                  <b-form-group>
                    <el-checkbox class="mt-2" size="mini" v-model="document.isSubsequentDocument" disabled="disabled">Subsequent</el-checkbox>
                  </b-form-group>
                </b-col>
                <b-col lg="5" class="text-right">
                  <b-form-group>
                    <el-button class="mt-1 text-ellipsis-button" size="mini" readonly="readonly" @click="openDocument(document)">{{ document.clientFilename ? document.clientFilename : 'No File' }}</el-button>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr/>
            </div>
          </b-col>
        </b-row>
      </b-card>
      </el-form>
    </div>

    <div class="text-right">
      <el-button icon="el-icon-plus" type="primary" @click="addExtraDocument()" v-if="step === 2" :disabled="isSubmitting" style="float: left;">Add Extra</el-button>
      <el-button icon="el-icon-arrow-left" type="primary" @click="previousStep(step)" v-if="step > 0" :disabled="isSubmitting">Back</el-button>
      <el-button icon="el-icon-arrow-right" type="primary" @click="nextStep(step)" v-if="step <= 2" :disabled="isSubmitting">Next</el-button>
      <el-button icon="el-icon-arrow-right" type="success" @click="complete(step)" v-if="step > 2 || row.id" :loading="isSubmitting" :disabled="isSubmitting">Complete</el-button>
    </div>
  </div>

  <pre v-if="isDebug">{{ row }}</pre>

  <UploadModal ref="uploadView"></UploadModal>

  <!-- Actions Modal -->
  <el-dialog title="Document Actions" :visible.sync="actionsModalVisible" width="800px">
    <div v-if="currentDocumentIndex !== null">
      <table style="width: 100%; table-layout: fixed;">
        <tr>
          <th style="padding: 8px; text-align: left; width: 30%;">Action Item</th>
          <th style="padding: 8px; text-align: left; width: 15%;">Status</th>
          <th style="padding: 8px; text-align: left; width: 55%;">Attachments</th>
        </tr>
        <tr v-for="action in actionTypes" :key="action.key">
          <td style="padding: 8px; vertical-align: top; word-break: break-word;">{{ action.label }}</td>
          <td style="padding: 8px; vertical-align: top;">
            <el-select size="small" v-model="row.documents[currentDocumentIndex][action.statusField]" placeholder="Select" style="width: 100%">
              <el-option label="Pending" value="Pending"/>
              <el-option label="Uploaded" value="Uploaded"/>
              <el-option label="Completed" value="Completed"/>
              <el-option label="Sent" value="Sent"/>
              <el-option label="N/A" value="N/A"/>
            </el-select>
          </td>
          <td style="padding: 8px; vertical-align: top;">
            <el-button size="mini" type="primary" @click="uploadActionAttachment(action.key)"><i class="el-icon-upload2"></i> Upload File</el-button>
            <div v-if="getActionAttachments(action.key).length > 0" style="margin-top: 8px; max-height: 150px; overflow-y: auto; border: 1px solid #ebeef5; border-radius: 4px;">
              <div style="padding: 8px; background: #f5f7fa; border-bottom: 1px solid #ebeef5; font-size: 12px; color: #909399;">
                Upload History ({{ getActionAttachments(action.key).length }} files)
              </div>
              <div v-for="(file, fileIndex) in getActionAttachments(action.key)" :key="fileIndex" style="display: flex; align-items: center; padding: 8px; border-bottom: 1px solid #ebeef5;">
                <span style="color: #909399; font-size: 12px; margin-right: 8px;">{{ fileIndex + 1 }}.</span>
                <el-tooltip :content="file.clientFilename" placement="top" :open-delay="300">
                  <el-link type="primary" @click="viewActionAttachment(action.key, file)" style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block;">{{ file.clientFilename }}</el-link>
                </el-tooltip>
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeActionAttachment(action.key, fileIndex)" style="margin-left: 8px;"></el-button>
              </div>
            </div>
            <div v-else style="margin-top: 8px; font-size: 12px; color: #c0c4cc;">No files uploaded</div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" :disabled="isSubmitting" @click="actionsModalVisible = false">Close</el-button>
      <el-button size="small" type="primary" :loading="isSubmitting" :disabled="isSubmitting" @click="saveActionsAndClose">Confirm</el-button>
    </span>
  </el-dialog>

  <!-- Share Document Modal -->
  <el-dialog title="Share Document" :visible.sync="shareModalVisible" width="700px">
    <div v-if="currentShareDocument">
      <h4>Share "{{ currentShareDocument.type }}" with other vendors</h4>

      <!-- Outgoing shares (shared TO other vendors) -->
      <div v-if="outgoingShares.length > 0" class="mb-3">
        <h5>Shared to:</h5>
        <el-table :data="outgoingShares" size="small" style="width: 100%">
          <el-table-column prop="targetCompanyName" label="Company Name"/>
          <el-table-column prop="targetAccountCode" label="Account Code" width="120"/>
          <el-table-column label="Actions" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="removeShare(scope.row.id)"><i class="el-icon-delete"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Incoming shares (shared FROM other vendors) -->
      <div v-if="incomingShares.length > 0" class="mb-3">
        <h5>Shared from:</h5>
        <el-table :data="incomingShares" size="small" style="width: 100%">
          <el-table-column prop="sourceCompanyName" label="Company Name"/>
          <el-table-column prop="sourceAccountCode" label="Account Code" width="120"/>
        </el-table>
      </div>

      <!-- Add new shares -->
      <div class="mt-3">
        <h5>Share with new vendors:</h5>
        <el-select
          v-model="selectedShareProfiles"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="Search and select vendors"
          :remote-method="searchProfiles"
          :loading="searchingProfiles"
          style="width: 100%">
          <el-option
            v-for="item in profileSearchResults"
            :key="item.id"
            :label="item.companyName + ' (' + item.accountCode + ')'"
            :value="item.id"
            :disabled="isAlreadyShared(item.id)">
          </el-option>
        </el-select>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="shareModalVisible = false">Close</el-button>
      <el-button size="small" type="primary" @click="shareDocument()" :disabled="selectedShareProfiles.length === 0">Share</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { getAccessToken, getErpProfile } from "@/utils/account-localstorage";
import { BButton, BModal } from "bootstrap-vue";
import apis from "@/configs/apis";
import { sortTree } from "@/views/erp/utils/object";
import { EventBus } from "@/views/erp/utils/event-bus";
import UploadModal from "@/views/erp/components/UploadModal.vue";
import { validateEmail } from "@/views/erp/utils/email";
import File from "@/views/erp/mixins/File";
import Prompt from "@/views/erp/mixins/Prompt";
import axios from "axios";

export default {
  mixins: [File, Prompt],
  components: {
    UploadModal,
    BModal, BButton
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      step: 0,
      isLoading: false,
      isSubmitting: false,
      profileReloadRequired: false,
      actionsModalVisible: false,
      currentDocumentIndex: null,
      currentActionType: null,
      uploadHistory: [],
      actionTypes: [
        { key: 'brCopy', label: 'BR Copy', statusField: 'actionBrCopy', filesField: 'actionBrCopyFiles' },
        { key: 'companySearch', label: 'Company Search', statusField: 'actionCompanySearch', filesField: 'actionCompanySearchFiles' },
        { key: 'applicationForm', label: 'Application Form', statusField: 'actionApplicationForm', filesField: 'actionApplicationFormFiles' },
        { key: 'declarationForm', label: 'Declaration Form', statusField: 'actionDeclarationForm', filesField: 'actionDeclarationFormFiles' },
        { key: 'assessmentForm', label: 'Assessment Form', statusField: 'actionAssessmentForm', filesField: 'actionAssessmentFormFiles' },
        { key: 'ecOrSocialSecurity', label: 'EC or 社保完税证明', statusField: 'actionEcOrSocialSecurity', filesField: 'actionEcOrSocialSecurityFiles' },
        { key: 'legalReview', label: 'Legal Review Email', statusField: 'actionLegalReview', filesField: 'actionLegalReviewFiles' },
        { key: 'priceComparison', label: 'Price Comparison', statusField: 'actionPriceComparison', filesField: 'actionPriceComparisonFiles' },
        { key: 'freeTextSupportingItem', label: 'Other', statusField: 'actionFreeTextSupportingItem', filesField: 'freeTextSupportingItemFiles' }
      ],
      shareModalVisible: false,
      currentShareDocument: null,
      currentShareDocumentIndex: null,
      currentDocumentShares: [],
      selectedShareProfiles: [],
      profileSearchResults: [],
      searchingProfiles: false,
      usersList: [],

      uploadIndex: null,
      uploadTitle: '',
      rules: {
        companyName: [
          { required: true, message: 'Please input Company Name (Invoice)', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: 'Please input Company Address', trigger: 'blur' }
        ],
        paymentTermDays: [
          { required: true, message: 'Please input Payment Term Days', trigger: 'blur' }
        ],
        paymentCurrency: [
          { required: true, message: 'Please input Payment Currency', trigger: 'blur' }
        ],
        accountCode: [
          { required: true, message: 'Please input Account Code', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (/[a-z]/.test(value || '')) callback(new Error('Account Code only accepts uppercase letters'));
            else callback();
          }, trigger: ['blur', 'change'] }
        ],
      },
      row: {
        companyName: null,
        companyNameInternal: null,
        companyAddress: null,
        contactPerson: null,
        contactNumber: null,
        brNumber: null,
        companyType: 'External',
        paymentTermDays: 30,
        keyAccount: null,
        accountCode: null,
        country: null,
        contactEmail: null,
        faContactEmail: null,
        corporateRegistrationNumber: null,
        contractType: null,
        paymentCurrency: 'HKD',
        tags: null,
        icpNumber: null,
        creditAmount: null,
        deposit: null,
        documents: [
          {
            type: 'Valid Business Registration Certificate',
            validDays: 12,
            isSubsequentDocument: false,
            serverFilename: null,
            clientFilename: null,
            isRequired: true,
            handleByUser: null,
            documentNumber: null,
            boxFileNo: null,
            dateOfIssue: null,
            dateOfExpiry: null,
            contractTemplate: null,
            status: null,
            picForNotification: [],
            remarks: null,
            description: null,
            actionBrCopy: null,
            actionCompanySearch: null,
            actionApplicationForm: null,
            actionDeclarationForm: null,
            actionAssessmentForm: null,
            actionEcOrSocialSecurity: null,
            actionLegalReview: null,
            actionPriceComparison: null,
            actionFreeTextSupportingItem: null,
            paymentTerm: null,
            deposit: null,
            depositCurrency: null,
            clientCodeDoc: null,
          },
          {
            type: 'Contract',
            validDays: 12,
            isSubsequentDocument: false,
            serverFilename: null,
            clientFilename: null,
            isRequired: true,
            handleByUser: null,
            documentNumber: null,
            boxFileNo: null,
            dateOfIssue: null,
            dateOfExpiry: null,
            contractTemplate: null,
            status: null,
            picForNotification: [],
            remarks: null,
            description: null,
            actionBrCopy: null,
            actionCompanySearch: null,
            actionApplicationForm: null,
            actionDeclarationForm: null,
            actionAssessmentForm: null,
            actionEcOrSocialSecurity: null,
            actionLegalReview: null,
            actionPriceComparison: null,
            actionFreeTextSupportingItem: null,
            paymentTerm: null,
            deposit: null,
            depositCurrency: null,
            clientCodeDoc: null,
          },
          {
            type: 'Application Form',
            validDays: 12,
            isSubsequentDocument: false,
            serverFilename: null,
            clientFilename: null,
            isRequired: true,
            handleByUser: null,
            documentNumber: null,
            boxFileNo: null,
            dateOfIssue: null,
            dateOfExpiry: null,
            contractTemplate: null,
            status: null,
            picForNotification: [],
            remarks: null,
            description: null,
            actionBrCopy: null,
            actionCompanySearch: null,
            actionApplicationForm: null,
            actionDeclarationForm: null,
            actionAssessmentForm: null,
            actionEcOrSocialSecurity: null,
            actionLegalReview: null,
            actionPriceComparison: null,
            paymentTerm: null,
            deposit: null,
            depositCurrency: null,
            clientCodeDoc: null,
          }
        ],
        companyContacts: [],
        faContacts: [],
      },
      activeName: 'Fulfillment',
      draftId: null,
      isDebug: false,
      documentTypeOptions: [
        { code: 'ADD', label: 'Addendum' },
        { code: 'APP', label: 'Application Form' },
        { code: 'CON', label: 'Contract' },
        { code: 'DECL',label:'Declaration'},
        { code: 'FOM' , label:'Form'},
        { code: 'LTR' , label:'Letter'},
        { code: 'MEMO' ,label:'Memo'},
        { code: 'MOU', label:'Menorandum of Understanding'},
        { code: 'NDA', label: 'Non-Disclosure Agreement' },
        { code: 'NOT', label: 'Notice' },
        { code: 'OTH', label: 'Others' },
        { code: 'PA', label: 'Power of Attorney' },
        { code: 'QUO', label: 'Quotation' },
        { code: 'TC', label: 'Terms & Conditions' }
      ],
      contractTemplateOptions: [
        'Standard Contract',
        'Customize Contract',
      ],
      documentStatusOptions: [
        'Pending',
        'Documented',
        'Expired',
        'Terminated',
        'Canceled',
      ],
    };
  },
  computed: {
    apis() {
      return apis
    },
    outgoingShares() {
      return this.currentDocumentShares.filter(s => s.direction === 'outgoing');
    },
    incomingShares() {
      return this.currentDocumentShares.filter(s => s.direction === 'incoming');
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.loadUsers();
    this.addCompanyContact();
    this.addFaContact();

    // Load existing profile
    if (this.$route.params.id !== undefined) {
      const id = this.$route.params.id;
      console.log('Load existing: ' + id);
      this.loadExisting(id);
    } else if (localStorage.getItem('draft')) {
      try {
        console.log('Load draft');
        this.loadDraft();
      } catch (e) {
        console.log('Load draft error: ' + e.message);
      }
    }
  },
  methods: {
    sortTree,
    getErpProfile,
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    getAccessToken,

    validateAccountCode() {
      if (typeof this.row.accountCode === 'string') {
        this.row.accountCode = this.row.accountCode.toUpperCase();
      }
      this.$nextTick(() => {
        if (this.$refs.mainForm) this.$refs.mainForm.validateField('accountCode');
      });
    },

    previousStep() {
      this.step -= 1;
    },

    nextStep() {
      if (this.step === 0) {
        this.$refs.mainForm.validate()
          .then(() => {
            // Intercom do not require documents
            if (this.row.companyType === 'InterCom') {
              this.row.documents.forEach(row => {
                row.isRequired = false;
              });
            }

            this.step += 1;
          })
          .catch((errors) => {
            let errorMessages = [];
            for (const i in errors) {
              for (const j in errors[i]) {
                errorMessages.push(errors[i][j]['message']);
              }
            }

            this.promptError(errorMessages.join(', '));
          });

      } else if (this.step === 1) {
        let errorMessages = [];
        this.row.companyContacts.forEach(row => {
          if ((!row.name || !row.phone || !row.email) && row.isRequired) {
            errorMessages.push("Company Contact " + row.name + ' is required');
          }

          if (row.email && !validateEmail(row.email)) {
            errorMessages.push("Company Contact Email " + row.email + ' is invalid');
          }
        });

        this.row.faContacts.forEach(row => {
          if ((!row.name || !row.phone || !row.email) && row.isRequired) {
            errorMessages.push("F&A Contact " + row.name + ' is required');
          }

          if (row.email && !validateEmail(row.email)) {
            errorMessages.push("F&A Contact Email " + row.email + ' is invalid');
          }
        });

        if (errorMessages.length > 0) {
          this.promptError(errorMessages.join(', '));
          return;
        }

        this.step += 1;
      } else if (this.step === 2) {
        let errorMessages = [];
        this.row.documents.forEach(row => {
          if (row.serverFilename === null && row.isRequired && !row.isSubsequentDocument) {
            errorMessages.push(row.type + ' is required');
          }
        });

        if (errorMessages.length > 0) {
          this.promptError(errorMessages.join(', '));
          return;
        }

        this.step += 1;
      } else if (this.step === 3) {
        this.step += 1;
      }
    },

    async complete() {
      if (this.isSubmitting) return;
      if (typeof this.row.accountCode === 'string') {
        this.row.accountCode = this.row.accountCode.toUpperCase();
      }
      this.isSubmitting = true;
      try {
        await this.refreshSavedProfile();
        if (this.row.id) await this.saveExisting();
        else await this.saveNew();
      } catch (e) {
        this.promptError(e);
      } finally {
        this.isSubmitting = false;
      }
    },

    addCompanyContact() {
      this.row.companyContacts.push({
        name: "",
        phone: "",
        email: "",
        isRequired: false
      });
    },

    removeCompanyContact(index) {
      this.row.companyContacts.splice(index, 1);
    },

    addFaContact() {
      this.row.faContacts.push({
        name: "",
        phone: "",
        email: "",
        isRequired: false
      });
    },

    removeFaContact(index) {
      this.row.faContacts.splice(index, 1);
    },

    async removeCompanyContactRemote(index, contact) {
      axios.delete(
        apis.erpVendorProfile + '/' + this.row.id + '/contact/' + contact.id,
      ).then(() => {
        this.row.companyContacts.splice(index, 1);
      }).catch(e => {
        this.promptError(e);
      });
    },

    async removeFaContactRemote(index, contact) {
      axios.delete(
        apis.erpVendorProfile + '/' + this.row.id + '/contact/' + contact.id
      ).then(() => {
        this.row.faContacts.splice(index, 1);
      }).catch(e => {
        this.promptError(e);
      });
    },

    async removeDocumentRemote(index, document) {
      axios.delete(
        apis.erpVendorProfile + '/' + this.row.id + '/document/' + document.id,
      ).then(() => {
        this.row.documents.splice(index, 1);
      }).catch(e => {
        this.promptError(e);
      });
    },

    uploadDocument(index) {
      this.$refs.uploadView.showUpload('Upload ' + this.row.documents[index].type, 'VENDOR_PROFILE', {maxSize: 104857600}, (form) => {
        this.isLoading = true;

        this.row.documents[index].clientFilename = form.clientFilename;
        this.row.documents[index].serverFilename = form.serverFilename;

        this.promptInfo("'" + this.row.documents[index].type + "' Upload Success");

        this.$refs.uploadView.hideUpload();

        this.isLoading = false;
      });
    },

    removeDocument(index) {
      this.row.documents.splice(index, 1);
    },

    openDocument(document) {
      this.downloadFile('VENDOR_PROFILE', document.serverFilename, document.clientFilename);
    },

    openActionsModal(index) {
      this.currentDocumentIndex = index;
      const doc = this.row.documents[index];
      console.log('Opening actions modal for document:', {
        id: doc.id,
        type: doc.type,
        actionBrCopyFiles: doc.actionBrCopyFiles,
        actionCompanySearchFiles: doc.actionCompanySearchFiles,
        actionApplicationFormFiles: doc.actionApplicationFormFiles,
        actionDeclarationFormFiles: doc.actionDeclarationFormFiles,
        actionAssessmentFormFiles: doc.actionAssessmentFormFiles,
        actionEcOrSocialSecurityFiles: doc.actionEcOrSocialSecurityFiles,
        actionLegalReviewFiles: doc.actionLegalReviewFiles,
        actionPriceComparisonFiles: doc.actionPriceComparisonFiles
      });
      this.actionsModalVisible = true;
      this.loadUploadHistory();
    },

    async refreshSavedProfile() {
      if (!this.profileReloadRequired) return;
      await this.loadExisting(this.row.id);
      this.profileReloadRequired = false;
    },

    async saveActionsAndClose() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      // Save the vendor profile if it already exists
      try {
        await this.refreshSavedProfile();
        if (this.row.id) {
          const dataToSave = JSON.parse(JSON.stringify(this.row));
          if (dataToSave.documents) {
            dataToSave.documents.forEach(doc => {
              if (Array.isArray(doc.picForNotification)) {
                doc.picForNotification = doc.picForNotification.join(',');
              }
            });
          }

          console.log('Saving vendor profile data:', dataToSave);
          console.log('Documents with file fields:', dataToSave.documents.map(d => ({
            id: d.id,
            type: d.type,
            actionBrCopyFiles: d.actionBrCopyFiles,
            actionCompanySearchFiles: d.actionCompanySearchFiles,
            actionApplicationFormFiles: d.actionApplicationFormFiles
          })));

          const response = await axios.put(
            apis.erpVendorProfile + '/' + this.row.id,
            dataToSave
          );
          // Refresh generated document/contact IDs before another profile save.
          this.profileReloadRequired = true;
          await this.refreshSavedProfile();
          console.log('Save response:', response.data);
          this.promptInfo('Actions saved successfully');
        }
        this.actionsModalVisible = false;
      } catch (e) {
        this.promptError(e);
      } finally {
        this.isSubmitting = false;
      }
    },

    async loadUploadHistory() {
      try {
        const response = await axios.get(apis.erpFileHistory + '/VENDOR_PROFILE');
        this.uploadHistory = response.data;
      } catch (error) {
        console.error('Error loading upload history:', error);
        this.uploadHistory = [];
      }
    },

    getTotalActionAttachments(document) {
      let total = 0;
      this.actionTypes.forEach(action => {
        if (action.filesField && document[action.filesField]) {
          try {
            const files = JSON.parse(document[action.filesField]) || [];
            total += files.length;
          } catch (e) {}
        }
      });
      return total;
    },

    getActionAttachments(actionKey) {
      if (this.currentDocumentIndex === null) return [];
      const doc = this.row.documents[this.currentDocumentIndex];
      const action = this.actionTypes.find(a => a.key === actionKey);
      if (!action || !action.filesField) return [];
      const filesJson = doc[action.filesField];
      if (!filesJson) return [];
      try {
        return JSON.parse(filesJson) || [];
      } catch (e) {
        return [];
      }
    },

    uploadActionAttachment(actionKey) {
      this.currentActionType = actionKey;
      const action = this.actionTypes.find(a => a.key === actionKey);
      const actionLabel = action?.label || actionKey;
      console.group('[VendorProfileForm] uploadActionAttachment');
      console.log('actionKey:', actionKey);
      console.log('action:', action);
      console.log('currentDocumentIndex:', this.currentDocumentIndex);
      console.groupEnd();
      this.$refs.uploadView.showUpload('Upload ' + actionLabel, 'VENDOR_PROFILE', {maxSize: 104857600}, (form) => {
        console.group('[VendorProfileForm] uploadActionAttachment callback');
        console.log('form received:', form);
        console.log('form.clientFilename:', form?.clientFilename);
        console.log('form.serverFilename:', form?.serverFilename);
        console.log('action.filesField:', action?.filesField);
        const doc = this.row.documents[this.currentDocumentIndex];
        console.log('doc before update:', JSON.parse(JSON.stringify(doc)));
        const filesField = action.filesField;
        let files = [];
        if (doc[filesField]) {
          try {
            files = JSON.parse(doc[filesField]) || [];
          } catch (e) {
            files = [];
          }
        }
        files.push({
          clientFilename: form.clientFilename,
          serverFilename: form.serverFilename
        });
        this.$set(doc, filesField, JSON.stringify(files));
        console.log('doc after update:', JSON.parse(JSON.stringify(doc)));
        console.groupEnd();
        this.promptInfo("'" + actionLabel + "' attachment uploaded successfully");
        this.$refs.uploadView.hideUpload();
        // Reload upload history to show the newly uploaded file
        this.loadUploadHistory();
      });
    },

    viewActionAttachment(actionKey, file) {
      this.downloadFile('VENDOR_PROFILE', file.serverFilename, file.clientFilename);
    },

    removeActionAttachment(actionKey, fileIndex) {
      const doc = this.row.documents[this.currentDocumentIndex];
      const action = this.actionTypes.find(a => a.key === actionKey);
      if (!action || !action.filesField) return;
      const filesField = action.filesField;
      let files = [];
      if (doc[filesField]) {
        try {
          files = JSON.parse(doc[filesField]) || [];
        } catch (e) {
          files = [];
        }
      }
      files.splice(fileIndex, 1);
      this.$set(doc, filesField, JSON.stringify(files));
    },

    addExtraDocument() {
      this.row.documents.push({
        type: '',
        validDays: 12,
        isSubsequentDocument: false,
        serverFilename: null,
        clientFilename: null,
        isRequired: false,
        handleByUser: null,
        documentNumber: null,
        boxFileNo: null,
        dateOfIssue: null,
        dateOfExpiry: null,
        contractTemplate: null,
        status: null,
        picForNotification: [],
        remarks: null,
        description: null,
        actionBrCopy: null,
        actionCompanySearch: null,
        actionApplicationForm: null,
        actionDeclarationForm: null,
        actionAssessmentForm: null,
        actionEcOrSocialSecurity: null,
        actionLegalReview: null,
        actionPriceComparison: null,
        actionFreeTextSupportingItem: null,
        actionAttachments: null,
        paymentTerm: null,
        deposit: null,
        depositCurrency: null,
        clientCodeDoc: null,
      });
    },

    async loadExisting(id) {
      return axios.get(apis.erpVendorProfile + '/' + id)
        .then(response => {
          this.row = response.data.data;

          console.log('Loaded vendor profile from backend:', {
            id: this.row.id,
            companyName: this.row.companyName,
            documentsCount: this.row.documents?.length || 0
          });

          // Sort documents by ID and convert picForNotification string to array
          if (this.row.documents && this.row.documents.length > 0) {
            this.row.documents.sort((a, b) => (a.id || 0) - (b.id || 0));
            this.row.documents.forEach(doc => {
              console.log('Document loaded:', {
                id: doc.id,
                type: doc.type,
                actionBrCopyFiles: doc.actionBrCopyFiles,
                actionCompanySearchFiles: doc.actionCompanySearchFiles,
                actionApplicationFormFiles: doc.actionApplicationFormFiles
              });

              if (doc.picForNotification && typeof doc.picForNotification === 'string') {
                doc.picForNotification = doc.picForNotification.split(',').filter(s => s.trim());
              } else if (!doc.picForNotification) {
                doc.picForNotification = [];
              }
            });
          }

          // Update breadcrumb
          this.$route.meta.breadcrumb[2].text = 'Edit ' + this.row.companyName;
          EventBus.$emit("route-meta-updated");
        });
    },

    async saveNew() {
      // Prepare data - convert picForNotification array to string
      const dataToSave = JSON.parse(JSON.stringify(this.row));
      if (dataToSave.documents) {
        dataToSave.documents.forEach(doc => {
          if (Array.isArray(doc.picForNotification)) {
            doc.picForNotification = doc.picForNotification.join(',');
          }
        });
      }

      return axios.post(
        apis.erpVendorProfile,
        dataToSave
      ).then(response => {
        this.promptInfo('Vendor Profile created successfully')

        // Delete the draft on complete
        if (this.draftId) {
            axios.delete(
              apis.erpVendorProfileDraft + '/' + this.draftId
            )
        }

        this.$router.push({
          name: "erp-vendor-profile",
        })
      });
    },

    async saveExisting() {
      // Prepare data - convert picForNotification array to string
      const dataToSave = JSON.parse(JSON.stringify(this.row));
      if (dataToSave.documents) {
        dataToSave.documents.forEach(doc => {
          if (Array.isArray(doc.picForNotification)) {
            doc.picForNotification = doc.picForNotification.join(',');
          }
        });
      }

      return axios.put(
        apis.erpVendorProfile + '/' + this.row.id,
        dataToSave
      ).then(() => {
        this.promptInfo('Vendor Profile updated successfully')

        this.$router.push({
          name: "erp-vendor-profile",
        })
      });
    },

    canGoToStep(step) {
      return this.step > step || this.row.id;
    },

    goToStep(step) {
      // For unsaved item, can only go back
      if (this.canGoToStep(step)) this.step = step;
    },

    debugMode() {
      this.isDebug = true;
    },

    async loadUsers() {
      axios.get(apis.accountList).then(response => {
        // Filter by isEnabled = true and map to expected format
        const accounts = response.data.data || [];
        this.usersList = accounts
          .filter(user => user.enabled === true)
          .map(user => ({
            id: user.userId,
            name: user.fullName || user.username
          }));
      }).catch(e => {
        console.error('Error loading users:', e);
      });
    },

    // Share document methods
    async openShareModal(index, document) {
      this.currentShareDocumentIndex = index;
      this.currentShareDocument = document;
      this.selectedShareProfiles = [];
      this.profileSearchResults = [];
      this.currentDocumentShares = [];

      // Load existing shares
      if (document.id) {
        try {
          const response = await axios.get(apis.erpVendorProfile + '/document/' + document.id + '/shares');
          this.currentDocumentShares = response.data.data || [];
        } catch (e) {
          console.error('Error loading shares:', e);
        }
      }

      this.shareModalVisible = true;
    },

    async searchProfiles(query) {
      if (query.length < 2) {
        this.profileSearchResults = [];
        return;
      }

      this.searchingProfiles = true;
      try {
        const response = await axios.get(apis.erpVendorProfile, {
          params: {
            companyName: '%' + query + '%',
            pageSize: 20
          }
        });
        // Filter out current profile
        this.profileSearchResults = (response.data.data.data || []).filter(p => p.id !== this.row.id);
      } catch (e) {
        console.error('Error searching profiles:', e);
        this.profileSearchResults = [];
      }
      this.searchingProfiles = false;
    },

    isAlreadyShared(profileId) {
      return this.currentDocumentShares.some(s => s.targetProfileId === profileId);
    },

    async shareDocument() {
      if (!this.currentShareDocument || this.selectedShareProfiles.length === 0) return;

      try {
        await axios.post(
          apis.erpVendorProfile + '/document/' + this.currentShareDocument.id + '/share',
          { targetProfileIds: this.selectedShareProfiles }
        );
        this.promptInfo('Document shared successfully');

        // Reload shares
        const response = await axios.get(apis.erpVendorProfile + '/document/' + this.currentShareDocument.id + '/shares');
        this.currentDocumentShares = response.data.data || [];
        this.selectedShareProfiles = [];
      } catch (e) {
        this.promptError(e);
      }
    },

    async removeShare(shareId) {
      try {
        await axios.delete(apis.erpVendorProfile + '/document/share/' + shareId);
        this.currentDocumentShares = this.currentDocumentShares.filter(s => s.id !== shareId);
        this.promptInfo('Share removed successfully');
      } catch (e) {
        this.promptError(e);
      }
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.action-badge {
  margin-right: 10px;
}
</style>
